import React, { useEffect, createElement } from 'react';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { HowItWorksSection } from '../HowItWorksSection';
export const HowItWorksPage = () => {
  useEffect(() => {
    document.title = 'How It Works — Maestro Connect';
    let metaDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = 'Learn how Maestro Connect helps music teachers manage students, lessons, and scheduling.';
  }, []);
  return <div className="w-full min-h-screen bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50] text-white font-sans" data-id="element-4740">
      <Navbar data-id="element-4741" />
      <main className="pt-20" data-id="element-4742">
        <HowItWorksSection data-id="element-4743" />
      </main>
      <Footer data-id="element-4744" />
    </div>;
};